import React from 'react';
import PropTypes from 'prop-types';
import Container from '../PageBuilder/lib/Container';
import EmbeddedVideo from '../PageBuilder/EmbeddedVideo';
import ConditionalElement from '../PageBuilder/helpers/ConditionalElement';

const VideoWidget = ({ url, variant, containerSettings }) => (
  <Container className="video-widget" settings={containerSettings}>
    <div className="container">
      <ConditionalElement
        tagName="div"
        condition={variant === 'inset'}
        attributes={{ className: 'shift-two-cols' }}
        childrenElements={<EmbeddedVideo videoUrl={url} />}
      />
    </div>
  </Container>
);

VideoWidget.title = 'Video';
VideoWidget.preview = 'text.png';
VideoWidget.category = 'Content';

VideoWidget.propTypes = {
  url: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  containerSettings: PropTypes.object.isRequired,
};

VideoWidget.defaults = {
  url: 'https://youtu.be/nX4Y3Qv51h8',
  variant: 'full',
  containerSettings: {},
};

VideoWidget.adminFields = {
  url: { type: 'text' },
  variant: { type: 'select', options: [['full', 'Full'], ['inset', 'Inset']] },
};

export default VideoWidget;
